<template>
    <el-card>
        <!-- 搜索 -->
        <el-row class="trainVideo__search">
            <div class="item">
                <span>类型:</span>
                <el-select v-model="searchList.tag" filterable placeholder="请选择" clearable>
                    <el-option v-for="(item, index) in tagTypeList" :key="index" :label="item.tagName"
                        :value="item.tagName">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <span>渠道:</span>
                <el-select v-model="searchList.channel" filterable placeholder="请选择" clearable>
                    <el-option v-for="(item, index) in channelList" :key="index" :label="item.name" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <el-button type="primary" @click="query(1)">搜索</el-button>
            <el-button type="success" @click="() => {
                dialogVisible = true
                dialogType = 0
            }">添加</el-button>
        </el-row>
        <!-- 表格 -->
        <el-row>
            <el-table border :data="trainVideoList">
                <el-table-column prop="id" label="ID" align="center">
                </el-table-column>
                <el-table-column prop="channel" label="渠道" align="center">
                </el-table-column>
                <el-table-column prop="language" label="语言" align="center">
                </el-table-column>
                <el-table-column prop="tag" label="视频分类" align="center">
                </el-table-column>
                <el-table-column prop="name" label="视频名称" align="center">
                </el-table-column>
                <el-table-column prop="description" label="视频描述" align="center">
                </el-table-column>
                <el-table-column prop="videoPic" label="视频封面" align="center">
                    <template slot-scope="scope">
                        <el-image :src="scope.row.videoPic" style="width: 100px; height: 100px;"
                            :preview-src-list="[scope.row.videoPic]" />
                    </template>
                </el-table-column>
                <el-table-column prop="videoUrl" label="视频内容" align="center">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.videoUrl" type="text"
                            @click="preview(scope.row.videoUrl)">预览</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="sort" label="视频排序" align="center">
                </el-table-column>
                <el-table-column prop="isTask" label="是否任务视频" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.isTask ? '是' : '否' }}
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" align="center">
                </el-table-column>
                <el-table-column prop="updateTime" label="修改时间" align="center">
                </el-table-column>
                <el-table-column prop="operator" label="操作人" align="center">
                </el-table-column>
                <el-table-column width="200" label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="update(scope.row)">编辑</el-button>
                        <el-button type="success" @click="deletes(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <!-- 分页 -->
        <el-row>
            <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize"
                @current-change="guaranteedHandleCurrentChange">
            </el-pagination>
        </el-row>
        <el-dialog :visible.sync="dialogVisible" :title="dialogType == 0 ? '添加' : '编辑'" width="30%"
            @close="closeDialog">
            <el-form :model="upDateInfo" label-width="120px" ref="ruleForm" :rules="ruleList">
                <el-form-item label="视频名称" prop="name">
                    <el-input v-model="upDateInfo.name" placeholder="请输入视频名称"></el-input>
                </el-form-item>
                <el-form-item label="渠道">
                    <el-select v-model="upDateInfo.channel" placeholder="请选择">
                        <el-option v-for="(item, index) in channelList" :key="index" :label="item.name"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="语言">
                    <el-select v-model="upDateInfo.language" placeholder="请选择">
                        <el-option v-for="(item, index) in langList" :key="index" :label="item.language"
                            :value="item.langCode">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="视频分类" prop="tag">
                    <el-select v-model="upDateInfo.tag" placeholder="请选择">
                        <el-option v-for="(item, index) in tagTypeList" :key="index" :label="item.tagName"
                            :value="item.tagName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="视频描述">
                    <el-input v-model="upDateInfo.description" type="textarea" :rows="3"></el-input>
                </el-form-item>
                <el-form-item label="视频封面" prop="videoPic">
                    <UploadSingleImg v-model="upDateInfo.videoPic" :on-upload="uploadFile"></UploadSingleImg>
                </el-form-item>
                <el-form-item label="视频内容" prop="videoUrl">
                    <UploadSingleImg v-model="upDateInfo.videoUrl" :on-upload="uploadFile"></UploadSingleImg>
                </el-form-item>
                <el-form-item label="视频排序">
                    <el-input v-model.number="upDateInfo.sort" type="number"></el-input>
                </el-form-item>
                <el-form-item label="是否任务视频">
                    <el-switch v-model="upDateInfo.isTask" :active-value="1" :inactive-value="0" active-text="是"
                        inactive-text="否"></el-switch>
                </el-form-item>
                <el-form-item label="是否有效">
                    <el-switch v-model="upDateInfo.status" :active-value="1" :inactive-value="0" active-text="是"
                        inactive-text="否"></el-switch>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button type="warning" @click="closeDialog">取消</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')">{{ dialogType == 0 ?
                    '添加' : '编辑'
                    }}</el-button>
            </div>
        </el-dialog>

        <!-- 视频预览弹窗 -->
        <el-dialog :visible.sync="videoPreviewVisible" title="视频预览" width="60%" :before-close="closeVideoPreview">
            <div class="video-preview-container">
                <video v-if="currentVideoUrl" :src="currentVideoUrl" controls style="width: 100%; max-height: 500px;"
                    autoplay>
                    您的浏览器不支持视频播放
                </video>
            </div>
            <div slot="footer">
                <el-button type="primary" @click="closeVideoPreview">关闭</el-button>
            </div>
        </el-dialog>
    </el-card>
</template>
<script>
import UploadSingleImg from '@/components/UploadSingleImg/UploadSingleImg.vue'
import { param } from 'jquery'

export default {
    components: {
        UploadSingleImg
    },
    data() {
        return {
            page: 1,
            pageSize: 30,
            total: 0,
            dialogVisible: false,
            dialogType: 0,
            videoPreviewVisible: false,
            currentVideoUrl: '',
            searchList: {
                tag: null,
                channel: null
            },
            upDateInfo: {
                name: null,
                channel: null,
                language: null,
                tag: null,
                name: null,
                description: null,
                videoPic: '',
                videoUrl: '',
                sort: null,
                isTask: null,
                status: null,
            },
            channelList: [],
            langList: [],
            tagTypeList: [],
            trainVideoList: [],
            ruleList: {
                'name': [{ required: true, message: '请输入视频名称', trigger: 'blur' },],
                'tag': [{ required: true, message: '请选择视频分类', trigger: 'change' },],
                'videoPic': [{ required: true, message: '请上传视频封面', trigger: 'blur' },],
                'videoUrl': [{ required: true, message: '请上传视频内容', trigger: 'blur' },],
            }
        }
    },
    created() {
        this.getChannel()
        this.getTagType()
        this.getLang()
        this.query(1)
    },
    methods: {
        preview(url) {
            this.currentVideoUrl = url
            this.videoPreviewVisible = true
        },
        closeVideoPreview() {
            this.videoPreviewVisible = false
            this.currentVideoUrl = ''
        },
        closeDialog() {
            this.dialogVisible = false
            this.upDateInfo = {
                name: null,
                channel: null,
                language: null,
                tag: null,
                name: null,
                description: null,
                videoPic: '',
                videoUrl: '',
                sort: null,
                isTask: null,
                status: null,
            }
        },
        guaranteedHandleCurrentChange(page) {
            this.query(page)
        },
        // 获取渠道选项
        async getChannel() {
            const { data: res } = await this.$axios({
                method: 'POST',
                url:
                    this.$store.getters.path.channelList +
                    '?username=' +
                    this.$store.getters.username +
                    '&token=' +
                    this.$store.getters.token,
            })

            if (res.code != 0) {
                return this.$message.error(res.msg)
            } else {
                this.channelList = [
                    { channelId: -1, name: 'all', value: 'all' },
                    ...res.data,
                ]
            }
        },
        //获取语言
        async getLang() {
            const { data: res } = await this.$axios({
                method: 'POST',
                url: this.$store.getters.path.langList,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                },
            })

            if (res.code != 0) {
                return this.$message.error(res.msg)
            } else {
                this.langList = res.data
            }
        },
        //获取tag类型
        async getTagType() {
            const { data: res } = await this.$axios({
                method: 'GET',
                url: this.$store.getters.path.config_train_video_tag_list_all,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                },
            })

            if (res.code != 0) {
                return this.$message.error(res.msg)
            } else {
                this.tagTypeList = res.data
            }
        },
        async query(page) {
            if (page) {
                this.page = page
            }
            const { data: res } = await this.$axios({
                method: 'post',
                url: this.$store.getters.path.config_train_video_list,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                    page: this.page,
                },
                data: {
                    ...this.searchList
                }
            })
            if (res.code === 0 || res.status === 0) {
                this.trainVideoList = res.data.data
                this.total = res.data.total
            } else {
                this.$message.error(res.msg || res.message)
            }
        },
        async uploadFile(file) {
            const formData = new FormData()
            formData.append('file', file)
            formData.append('cover', 0)
            formData.append('dir', 'member/benefit')
            const { data: res } = await this.$axios.post(
                this.$store.getters.path.hostmgr_upload +
                '?username=' +
                this.$store.getters.username +
                '&token=' +
                this.$store.getters.token,
                formData
            )
            return { code: res.code, url: res.data }
        },
        async deletes(id) {
            this.$alert('确定删除该视频吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const { data: res } = await this.$axios({
                    method: 'get',
                    url: this.$store.getters.path.config_train_video_delete,
                    params: {
                        username: this.$store.getters.username,
                        token: this.$store.getters.token,
                        id
                    },
                })
                if (res.code != 0) {
                    return this.$message.error(res.msg)
                } else {
                    this.$message.success('操作成功')
                    this.query()
                }
            })
        },
        update(info) {
            this.dialogVisible = true
            this.dialogType = 1
            this.upDateInfo = info
        },
        submitForm(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    this.submit(this.upDateInfo, this.closeDialog)
                }
            })
        },
        async submit(info, fun) {
            const data = JSON.parse(JSON.stringify(info))
            const { data: res } = await this.$axios({
                method: 'post',
                url: this.$store.getters.path.config_train_video_submit,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                },
                data
            })
            if (res.code != 0) {
                return this.$message.error(res.msg)
            } else {
                fun && fun()
                this.$message.success('操作成功')
                this.query(1)
            }
        }
    }
}
</script>
<style scoped lang="scss">
.trainVideo {
    &__title {
        font-size: 28px;
        font-weight: 700;
        margin-bottom: 20px;
    }

    &__search {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;

        .item {
            display: flex;
            align-items: center;
            width: max-content;
        }

        span {
            font-size: 20px;
            font-weight: 600;
            margin-right: 15px;
        }

    }
}

.video-preview-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 300px;

    video {
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
}
</style>